export default {
  reset_password: { id: 'reset_password' },
  back_to_signin: { id: 'back_to_signin' },
  submit: { id: 'submit' },
}
